import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRightOnRectangleIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../core/providers/AuthProvider';
import { confirmAction } from '../utils/dialogs';

// The student pages' account button and its dropdown (Profile, Logout), styled like the staff
// header's NotificationBell.
function StudentAccountMenu() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handlePointerDown = (e) => {
      if (!containerRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [open]);

  const handleSignOut = async () => {
    setOpen(false);
    const confirmed = await confirmAction({
      title: 'Are you sure you want to log out?',
      text: "You'll need to sign in again to continue.",
      confirmText: 'Sign Out',
      danger: true,
    });
    if (!confirmed) return;

    await signOut();
    navigate('/', { replace: true });
  };

  return (
    <div ref={containerRef} className="relative ml-auto shrink-0">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-label="Account menu"
        aria-expanded={open}
        className="p-1 text-white/80 hover:text-white"
      >
        <UserCircleIcon className="h-9 w-9" />
      </button>

      {open && (
        <div className="absolute right-0 z-30 mt-2 w-56 rounded-lg border border-gray-200 bg-white shadow-lg">
          <Link
            to="/student-dashboard/profile"
            onClick={() => setOpen(false)}
            className="flex items-center gap-2 px-4 py-3 text-lg font-medium text-gray-700 hover:bg-gray-50"
          >
            <UserCircleIcon className="h-5 w-5" />
            Profile
          </Link>
          <button
            type="button"
            onClick={handleSignOut}
            className="flex w-full items-center gap-2 rounded-b-lg border-t border-gray-200 px-4 py-3 text-lg font-medium text-red-600 hover:bg-red-50"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default StudentAccountMenu;
